// utils/authService.ts

import { axiosInstance as axios } from "./axios";

export const apiLogin = async (u: string, p: string) => {
  const response = await axios.post("/auth", { u, p, aodm:1 });
  return response.data;
};
